import React from "react";
import { Chart } from "react-google-charts";

let task = [];
let targetted = [];
let untargetted = [];
class DonutChart extends React.Component {
  constructor(props) {
    super(props);
    task = [];
    targetted = [];
    untargetted = [];
    this.state = {
      targetted: this.props.targetted,
      untargetted: this.props.untargetted,
    };
    task.push("Task");
    task.push("Hours per Day");
    targetted.push("Targeted");
    targetted.push(parseInt(this.props.targetted));
    untargetted.push("Untargeted");
    untargetted.push(
      parseInt(this.props.untargetted) - parseInt(this.props.targetted)
    );
  }

  render() {
    return (
      <Chart
        chartType="PieChart"
        width="auto"
        data={[task, targetted, untargetted]}
        options={{
          sliceVisibilityThreshold: 0,
          legend: { position: "bottom", alignment: "center" },
          pieHole: 0.4,
          is3D: false,
          colors: [
            // "#f5801f",
						"#69ff45",
            "#808080",
            "#6691c6",
            "#b4413e",
            "#6d833d",
            "#7e60a0",
            "#ffff47",
            "#d30fae",
            "#3599b8",
            "#dfbfbf",
            "#4ac5bb",
            "#5f6b6d",
            "#fb8281",
            "#f4d25a",
            "#7f898a",
            "#a4ddee",
            "#fdab89",
            "#b687ac",
            "#28738a",
            "#a78f8f",
            "#168980",
            "#293537",
            "#bb4a4a",
            "#b59525",
            "#475052",
          ] /*colors: ['#0c3c54','#708690']*/,
        }}
      />
    );
  }
}

export default DonutChart;



// WEBPACK FOOTER //
// ./src/views/Audiences/DonutChart.jsx